import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { store } from "../store/store";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        login: {
          title: "Login",
          description: "How do I get started?",
          email: "Enter Email",
          password: "Enter Password",
          forgot: "Forgot Password?",
          signIn: "Sign in",
          welcome: "Welcome to",
          pleaseFillFields: "Please Fill Required Fields!",
          enterValidEmail: "Please enter a valid email",
          enterEmail: "Please enter your email address",
          enterPassword: "Please enter your password",
          success: "Login successful!",
          error: "Login failed. Please try again.",
        },
        forgotPassword: {
          title: "Forgot Password",
          description:
            "Enter your registered email address and phone number. We'll send you a code to reset your password.",
          email: "Enter Email",
          sendOTP: "Send OTP",
          emailRequired: "Email is required",
          invalidEmail: "Please enter a valid email address",
          sendingOTP: "Sending OTP...",
          sendOTPError: "Failed to send OTP. Please try again.",
        },
        createNewPassword: {
          title: "Create New Password",
          description: "Set a new password for your account.",
          newPassword: "New Password",
          confirmPassword: "Confirm New Password",
          reset: "Reset Password",
          enterNewPassword: "Enter New Password",
          confirmNewPassword: "Confirm New Password",
        },
        verifyOTP: {
          title: "Verify OTP",
          description: "We've sent you a One-Time Password (OTP) to your email",
          email: "Email",
          otp: "Enter OTP",
          verify: "Verify",
          resend: "RESEND IT",
          didntReceive: "Didn't Receive the OTP?",
          timeLeft: "Time Left",
        },
        sidebar: {
          dashboard: "Dashboard",
          userManagement: "User Management",
          providerManagement: "Provider Management",
          orderManagement: "Order Management",
          category: "Category",
          categoryManagement: "Category Management",
          subCategoryManagement: "Sub Category",
          subToSubCategoryManagement: "Sub-to-Sub Category",
          ratingsManagement: "Ratings Management",
          paymentManagement: "Payment Management",
          providerPayout: "Provider Payout",
          catchUpsManagement: "Catch Ups Management",
          account: "Account"

        },
        auth: {
          logout: "Logout",
        },
        notifications: {
          title: "Notifications",
        },
        dashboard: {
          title: "Dashboard",
          totalUsers: "Total Users",
          activeProviders: "Active Providers",
          pendingPayouts: "Pending Payouts",
          newProviderRequest: "New Provider Request",
          viewAll: "View all",
          ordersToday: "Orders Today",
          totalRevenue: "Total Revenue",
          thisWeek: "This week",
          thisMonth: "This month",
          thisYear: "This year",
          orderStatus: "Order Status",
          numberOfOrders: "Num",
          completed: "Completed",
          pending: "Pending",
          cancel: "Cancel",
          providerList: "Provider List",
          providerName: "Provider Name",
          categoryName: "Category Name",
          actions: "Actions",
          approve: "Approve",
          reject: "Reject",
          releaseNow: "Release Now",
          viewDetails: "View Details",
          sar: "Sar",
          providers: "Provider",
          thursdayRevenue: "Thursday Revenue",
        },
        table: {
          name: "Name",
          email: "Email",
          category: "Category",
          status: "Status",
          freeTriesLeft: "Free Tries Left",
          verified: "Verified",
          orderId: "Order ID",
          userName: "User Name",
          providerName: "Provider Name",
          date: "Date",
          time: "Time",
          amount: "Amount",
          categoryName: "Category Name",
          subCategory: "Sub Category",
          sub_to_subCategory: "Sub-To-Sub Category",
          totalProviders: "Total Providers",
          totalOrders: "Total Orders",
          lastUpdated: "Last Updated",
          user: "User",
          provider: "Provider",
          rating: "Rating",
          review: "Review",
          method: "Method",
          transactionId: "Transaction ID",
          noOfOrders: "No of Orders",
          totalAmount: "Total Amount",
          payoutDate: "Payout Date",
          payoutTime: "Payout Time",
          release: "Release",
          hold: "Hold",
          view: "View",
          approve: "Approve",
          reject: "Reject",
          updateTries: "Update Tries",
          deactivate: "Deactivate",
          activate: "Activate",
          edit: "Edit",
          delete: "Delete",
          action: "Action",
        },
        buttons: {
          addNewCategory: "Add New Category",
          addNewSubCategory: "Add New Sub Category",
          addNewSubToSubCategory: "Add New Sub-To-Sub Category",
        },
        search: {
          byName: "By Name",
          byEmail: "By Email",
          byCategory: "By Category",
          byOrderId: "By Order ID",
          byUserName: "By User Name",
          byProviderName: "By Provider Name",
          bySubCategory: "By Sub Category",
          bySubToSubCategory: "By Sub-To-Sub Category",
          byStatus: "By Status",
          byUser: "By User",
          byProvider: "By Provider",
          byRating: "By Rating",
          byTransactionId: "By Transaction ID",
          searchName: "Search Name",
          searchEmail: "Search Email",
          searchCategory: "Search Category",
          searchOrderId: "Search Order ID",
          searchUserName: "Search User Name",
          searchProviderName: "Search Provider Name",
          searchSubCategory: "Search Sub Category",
          searchSubToSubCategory: "Search Sub-To-Sub Category",
          searchStatus: "Search Status",
          searchUser: "Search User",
          searchProvider: "Search Provider",
          searchRating: "Search Rating",
          searchTransactionId: "Search Transaction ID",
          searchCatchUp: "Search Catch Ups"
        },
        tabs: {
          all: "All",
          approved: "Approved",
          pendingRequests: "Pending Requests",
          rejected: "Rejected",
          deactivated: "Deactivated",
          completed: "Completed",
          inProgress: "In Progress",
          cancelled: "Cancelled",
          pending: "Pending",
          paid: "Paid",
          active: "Active",
          inactive: "Inactive",
          released: "Released",
          eligible: "Eligible",
          hold: "Hold",
        },
        rating: {
          all: "Ratings",
          fiveStars: "5 Stars",
          fourStars: "4 Stars",
          threeStars: "3 Stars",
          twoStars: "2 Stars",
          oneStar: "1 Star",
        },
        pagination: {
          showing: "Showing",
          of: "of",
          first: "<< First",
          back: "< Back",
          next: "Next >",
          last: "Last >>",
        },
        providerDetail: {
          title: "Provider Detail",
          approve: "Approve",
          deactivate: "Deactivate",
          reject: "Reject",
          information: "Provider Information",
          name: "Provider Name",
          email: "Email Address",
          phone: "Phone Number",
          dateRegistered: "Date Registered",
          categories: "Categories",
          noCategories: "No categories assigned",
          location: "Location",
          noLocation: "Location not available",
          status: "Status",
          verified: "Verified",
        },
        orderDetail: {
          title: "Order Detail",
          orderInfo: "Order Info",
          orderId: "Order Id",
          orderDate: "Order Date",
          address: "Address",
          providerName: "Provider Name",
          providerContactNum: "Provider Contact Num",
          userName: "User Name",
          userContactNum: "User Contact Num",
          category: "Category",
          status: "Status",
          completed: "Completed",
          inProgress: "In Progress",
          cancelled: "Cancelled",
          paymentInfo: "Payment Info",
          subTotal: "Sub Total",
          export: "Export",
        },
        categoryDetail: {
          addTitle: "Add Category",
          editTitle: "Edit Category",
          save: "Save Category",
          update: "Update Category",
          cancel: "Cancel",
          upload: "Upload",
          uploadTagline: "Upload The Category Icon",
          categoryName: "Category Name",
          subCategoryName: "Sub Category Name",
          sub_subCategoryName: "Sub-Sub Category Name",
          description: "Description",
          chooseStatus: "Choose Status",
          active: "Active",
          inActive: "In-Active",
        },
        subCategoryDetail: {
          addTitle: "Add Sub Category",
          editTitle: "Edit Sub Category",
          save: "Save Sub Category",
          update: "Update Sub Category",
          cancel: "Cancel",
          upload: "Upload",
          uploadTagline: "Upload The Sub Category Icon",
          categoryName: "Category Name",
          subCategoryName: "Sub Category Name",
          sub_to_subCategoryName: "Sub-To-Sub Category Name",
          description: "Description",
          chooseStatus: "Choose Status",
          active: "Active",
          inActive: "In-Active",
        },
        subToSubCategoryDetail: {
          addTitle: "Add Sub-To-Sub Category",
          editTitle: "Edit Sub-To-Sub Category",
          save: "Save Sub-To-Sub Category",
          update: "Update Sub-To-Sub Category",
          cancel: "Cancel",
          upload: "Upload",
          uploadTagline: "Upload The Sub-To-Sub Category Icon",
          categoryName: "Category Name",
          subCategoryName: "Sub Category Name",
          sub_to_subCategoryName: "Sub-To-Sub Category Name",
          description: "Description",
          chooseStatus: "Choose Status",
          active: "Active",
          inActive: "In-Active",
        },
        modal: {
          reviewDetail: "Review Detail",
          approve: "Approve",
          delete: "Delete",
          reject: "Reject",
          userName: "User Name",
          providerName: "Provider Name",
          review: "Review",
          ratings: "Ratings",
          status: "Status",
        },
        paymentDetail: {
          title: "Payment Detail",
          userInfo: "User Info",
          userName: "User Name",
          userEmail: "User Email",
          providerInfo: "Provider Info",
          providerName: "Provider Name",
          providerEmail: "Provider Email",
          providerId: "Provider ID",
          orderInfo: "Order Info",
          orderId: "Order ID",
          orderDate: "Order Date",
          category: "Category",
          status: "Status",
          paymentMethod: "PaymentMethod",
          paymentDate: "Payment Date",
          paymentSummary: "Payment Summary",
          serviceAmount: "Service Amount",
          fusatyCommission: "Fusaty Commisssion",
          transactionTime: "Transaction Time",
          paymentStatus: "Payment Status",
          export: "Export",
        },
        payoutDetail: {
          title: "Payout Detail",
          orderId: "Order Id",
          userName: "User Name",
          providerName: "ProviderName",
          serviceName: "Service Name",
          category: "Category",
          orderCompletionDate: "Order Completion Date",
          orderAmount: "Order Amount",
          fusatyCommission: "Fusaty Commission",
          payoutAmount: "payout Amount",
          status: "Status",
          payoutTimingInfo: "Payout Timing Info",
          orderCompletionTime: "Order Completion Time",
          eligibleForPayout: "Eligible for Payout",
          action: "Action",
          autoRelease: "Auto Release",
          releaseNow: "Release Now",
          hold: "Hold",
          save: "Save",
        },
        catchUps: {
          addTitle: "Add Catch Up",
          save: "Save",
          cancel: "Cancel",
          modalPlaceholder: "Catch Up form will be placed here.",
          title: "Title",
          titlePlaceholder: "Enter title",
          category: "Category",
          categoryPlaceholder: "Select category",
          categories: {
            specialOffers: "Special Offers",
            whereToGo: "Where to go?",
            activities: "Activities",
            sports: "Sports",
            specialDeals: "Special Deals"
          },
          dates: "Dates",
          fromDate: "From Date",
          toDate: "To Date",
          times: "Times",
          fromTime: "From Time",
          toTime: "To Time",
          contact: "Contact",
          link: "Link",
          contactPlaceholder: "tel:+971501234567",
          linkPlaceholder: "https://www.xyz.com",
          selectStartTime: "Select start time",
          selectEndTime: "Select end time"
        },
        map: {
          loading: "Loading map...",
          selectLocation: "Select Location",
          searchPlaceholder: "Select Destination",
          coordinates: "Lat: \"{{lat}}\" | Lng: \"{{lng}}\""
        }

      },
    },
    ar: {
      translation: {
        notifications: {
          title: "الإشعارات",
        },
        auth: {
          logout: "تسجيل الخروج",
        },
        login: {
          title: "تسجيل الدخول",
          description: "كيف أبدأ؟",
          email: "أدخل البريد الإلكتروني",
          password: "أدخل كلمة المرور",
          forgot: "نسيت كلمة المرور؟",
          signIn: "تسجيل الدخول",
          welcome: "مرحباً بك في",
          pleaseFillFields: "يرجى ملء الحقول المطلوبة!",
          enterValidEmail: "يرجى إدخال بريد إلكتروني صالح",
          enterEmail: "يرجى إدخال عنوان بريدك الإلكتروني",
          enterPassword: "يرجى إدخال كلمة المرور",
          success: "تم تسجيل الدخول بنجاح!",
          error: "فشل تسجيل الدخول. يرجى المحاولة مرة أخرى.",
        },
        forgotPassword: {
          title: "نسيت كلمة المرور",
          description:
            "أدخل بريدك الإلكتروني المسجل أو رقم هاتفك. سنرسل لك رمزًا لإعادة تعيين كلمة المرور.",
          email: "أدخل البريد الإلكتروني",
          sendOTP: "إرسال OTP",
          emailRequired: "البريد الإلكتروني مطلوب",
          invalidEmail: "يرجى إدخال عنوان بريد إلكتروني صالح",
          sendingOTP: "جاري إرسال OTP...",
          sendOTPError: "فشل في إرسال OTP. يرجى المحاولة مرة أخرى.",
        },
        createNewPassword: {
          title: "إنشاء كلمة مرور جديدة",
          description: "اضبط كلمة مرور جديدة لحسابك.",
          newPassword: "كلمة المرور الجديدة",
          confirmPassword: "تأكيد كلمة المرور الجديدة",
          reset: "إعادة تعيين كلمة المرور",
          enterNewPassword: "أدخل كلمة المرور الجديدة",
          confirmNewPassword: "تأكيد كلمة المرور الجديدة",
        },
        verifyOTP: {
          title: "تحقق من مكتب المدعي العام",
          description:
            "لقد أرسلنا إليك كلمة مرور لمرة واحدة (مكتب المدعي العام) إلى بريدك الإلكتروني",
          email: "البريد الإلكتروني",
          otp: "أدخل مكتب المدعي العام",
          verify: "تحقق",
          resend: "أعد إرسالها",
          didntReceive: "لم تتلقَ الـ مكتب المدعي العام؟",
          timeLeft: "الوقت المتبقي",
        },
        sidebar: {
          dashboard: "لوحة التحكم",
          userManagement: "إدارة المستخدمين",
          providerManagement: "إدارة المزودين",
          orderManagement: "إدارة الطلبات",
          category: "الفئة",
          categoryManagement: "إدارة الفئات",
          subCategoryManagement: "الفئات الفرعية",
          subToSubCategoryManagement: "الفئات الفرعية الفرعية",
          ratingsManagement: "إدارة التقييمات",
          paymentManagement: "إدارة المدفوعات",
          providerPayout: "دفع المزودين",
          catchUpsManagement: "إدارة اللحاق بالركب",
          account: "الحساب"
        },
        dashboard: {
          title: "لوحة التحكم",
          totalUsers: "إجمالي المستخدمين",
          activeProviders: "المزودين النشطين",
          pendingPayouts: "المدفوعات المعلقة",
          newProviderRequest: "طلب إضافة مزود جديد",
          viewAll: "عرض الكل",
          ordersToday: "الطلبات اليومية",
          totalRevenue: "الإيرادات الإجمالية",
          thisWeek: "هذا الأسبوع",
          thisMonth: "هذا الشهر",
          thisYear: "هذا العام",
          orderStatus: "حالة الطلب",
          numberOfOrders: "عدد",
          completed: "مكتمل",
          pending: "قيد الانتظار",
          cancel: "إلغاء",
          providerList: "قائمة المزودين",
          providerName: "اسم المزود",
          categoryName: "اسم الفئة",
          actions: "الإجراءات",
          approve: "موافقة",
          reject: "رفض",
          releaseNow: "إصدار الآن",
          viewDetails: "عرض التفاصيل",
          sar: "ريال",
          providers: "المزودين",
          thursdayRevenue: "الإيرادات الخميسية",
        },
        table: {
          name: "الاسم",
          email: "البريد الإلكتروني",
          category: "الفئة",
          status: "الحالة",
          freeTriesLeft: "المحاولات المجانية المتبقية",
          verified: "متحقق",
          orderId: "رقم الطلب",
          userName: "اسم المستخدم",
          providerName: "اسم المزود",
          date: "التاريخ",
          time: "وقت",
          amount: "المبلغ",
          categoryName: "اسم الفئة",
          subCategory: "الفئة الفرعية",
          sub_to_subCategory: "الفئة الفرعية للفرعية",
          totalProviders: "إجمالي المزودين",
          totalOrders: "إجمالي الطلبات",
          lastUpdated: "آخر تحديث",
          user: "مستخدم",
          provider: "مزود",
          rating: "التقييم",
          review: "مراجعة",
          method: "الطريقة",
          transactionId: "معرف المعاملة",
          noOfOrders: "عدد الطلبات",
          totalAmount: "المبلغ الإجمالي",
          payoutDate: "تاريخ الدفع",
          payoutTime: "وقت الدفع",
          release: "إصدار",
          hold: "معلّق",
          view: "عرض",
          approve: "موافقة",
          reject: "رفض",
          updateTries: "تحديث المحاولات",
          deactivate: "إلغاء التفعيل",
          activate: "تفعيل",
          edit: "تعديل",
          delete: "حذف",
          action: "الإجراء",
        },
        buttons: {
          addNewCategory: "إضافة فئة جديدة",
          addNewSubCategory: "إضافة فئة فرعية جديدة",
          addNewSubToSubCategory: "إضافة فئة فرعية جديدة للفرعية",
        },
        search: {
          byName: "بالاسم",
          byEmail: "بالبريد الإلكتروني",
          byCategory: "بالفئة",
          byOrderId: "برقم الطلب",
          byUserName: "بالاسم",
          byProviderName: "بالاسم",
          bySubCategory: "بالفئة الفرعية",
          bySubToSubCategory: "بالفئة الفرعية للفرعية",
          byStatus: "بالحالة",
          byUser: "حسب المستخدم",
          byProvider: "حسب المزود",
          byRating: "حسب التقييم",
          byTransactionId: "حسب معرف المعاملة",
          searchName: "البحث بالاسم",
          searchEmail: "البحث بالبريد الإلكتروني",
          searchCategory: "البحث بالفئة",
          searchOrderId: "البحث برقم الطلب",
          searchUserName: "البحث بالاسم",
          searchProviderName: "البحث بالاسم",
          searchSubCategory: "البحث بالفئة الفرعية",
          searchSubToSubCategory: "البحث بالفئة الفرعية للفرعية",
          searchStatus: "البحث بالحالة",
          searchUser: "بحث عن مستخدم",
          searchProvider: "بحث عن مزود",
          searchRating: "بحث عن تقييم",
          searchTransactionId: "بحث عن معرف المعاملة",
          searchCatchUp: "البحث عن اللحاق بالركب",

        },
        tabs: {
          all: "الكل",
          approved: "موافق عليه",
          pendingRequests: "طلبات معلقة",
          rejected: "مرفوض",
          deactivated: "معطل",
          completed: "مكتمل",
          inProgress: "قيد التنفيذ",
          cancelled: "ملغي",
          pending: "قيد الانتظار",
          paid: "مدفوع",
          active: "نشط",
          inactive: "غير نشط",
          released: "تم الإصدار",
          eligible: "مؤهل",
          hold: "معلّق",
        },
        rating: {
          all: "جميع التقييمات",
          fiveStars: "5 نجوم",
          fourStars: "4 نجوم",
          threeStars: "3 نجوم",
          twoStars: "2 نجوم",
          oneStar: "1 نجوم",
        },
        pagination: {
          showing: "عرض",
          of: "من",
          first: "<< الأول",
          back: "< السابق",
          next: "التالي >",
          last: "الأخير >>",
        },
        providerDetail: {
          title: "تفاصيل المزود",
          approve: "موافقة",
          deactivate: "إلغاء التفعيل",
          reject: "رفض",
          information: "معلومات المزود",
          name: "اسم المزود",
          email: "عنوان البريد الإلكتروني",
          phone: "رقم الهاتف",
          dateRegistered: "تاريخ التسجيل",
          categories: "الفئات",
          noCategories: "لم يتم تعيين فئات",
          location: "الموقع",
          noLocation: "الموقع غير متاح",
          status: "الحالة",
          verified: "متحقق",
        },
        orderDetail: {
          title: "تفاصيل الطلب",
          orderInfo: "معلومات الطلب",
          orderId: "رقم الطلب",
          orderDate: "تاريخ الطلب",
          address: "العنوان",
          providerName: "اسم المزود",
          providerContactNum: "رقم اتصال المزود",
          userName: "اسم المستخدم",
          userContactNum: "رقم اتصال المستخدم",
          category: "الفئة",
          status: "الحالة",
          completed: "مكتمل",
          inProgress: "قيد التنفيذ",
          cancelled: "ملغى",
          paymentInfo: "معلومات الدفع",
          subTotal: "الإجمالي الفرعي",
          export: "تصدير",
        },
        categoryDetail: {
          addTitle: "إضافة فئة",
          editTitle: "تعديل الفئة",
          save: "حفظ الفئة",
          update: "تحديث الفئة",
          cancel: "إلغاء",
          upload: "رفع",
          uploadTagline: "قم برفع أيقونة الفئة",
          categoryName: "اسم الفئة",
          subCategoryName: "اسم الفئة الفرعية",
          sub_subCategoryName: "اسم الفئة الفرعية الفرعية",
          description: "الوصف",
          chooseStatus: "اختر الحالة",
          active: "نشط",
          inActive: "غير نشط",
        },
        subCategoryDetail: {
          addTitle: "إضافة فئة فرعية",
          editTitle: "تعديل الفئة الفرعية",
          save: "حفظ الفئة الفرعية",
          update: "تحديث الفئة الفرعية",
          cancel: "إلغاء",
          upload: "رفع",
          uploadTagline: "قم برفع أيقونة الفئة الفرعية",
          categoryName: "اسم الفئة",
          subCategoryName: "اسم الفئة الفرعية",
          sub_to_subCategoryName: "اسم الفئة الفرعية للفرعية",
          description: "الوصف",
          chooseStatus: "اختر الحالة",
          active: "نشط",
          inActive: "غير نشط",
        },
        subToSubCategoryDetail: {
          addTitle: "إضافة فئة فرعية للفرعية",
          editTitle: "تعديل الفئة الفرعية للفرعية",
          save: "حفظ الفئة الفرعية للفرعية",
          update: "تحديث الفئة الفرعية للفرعية",
          cancel: "إلغاء",
          upload: "رفع",
          uploadTagline: "قم برفع أيقونة الفئة الفرعية للفرعية",
          categoryName: "اسم الفئة",
          subCategoryName: "اسم الفئة الفرعية",
          sub_to_subCategoryName: "اسم الفئة الفرعية للفرعية",
          description: "الوصف",
          chooseStatus: "اختر الحالة",
          active: "نشط",
          inActive: "غير نشط",
        },
        modal: {
          reviewDetail: "تفاصيل المراجعة",
          approve: "الموافقة",
          delete: "حذف",
          reject: "رفض",
          userName: "اسم المستخدم",
          providerName: "اسم المزود",
          review: "مراجعة",
          ratings: "التقييمات",
          status: "الحالة",
        },
        paymentDetail: {
          title: "تفاصيل الدفع",
          userInfo: "معلومات المستخدم",
          userName: "اسم المستخدم",
          userEmail: "بريد المستخدم الإلكتروني",
          providerInfo: "معلومات المزود",
          providerName: "اسم المزود",
          providerEmail: "بريد المزود الإلكتروني",
          providerId: "معرف المزود",
          orderInfo: "معلومات الطلب",
          orderId: "معرف الطلب",
          orderDate: "تاريخ الطلب",
          category: "الفئة",
          status: "الحالة",
          paymentMethod: "طريقة الدفع",
          paymentDate: "تاريخ الدفع",
          paymentSummary: "ملخص الدفع",
          serviceAmount: "مبلغ الخدمة",
          fusatyCommission: "عمولة Fusaty",
          transactionTime: "وقت المعاملة",
          paymentStatus: "حالة الدفع",
          export: "تصدير",
        },
        payoutDetail: {
          title: "تفاصيل الدفع",
          orderId: "معرف الطلب",
          userName: "اسم المستخدم",
          providerName: "اسم المزود",
          serviceName: "اسم الخدمة",
          category: "الفئة",
          orderCompletionDate: "تاريخ إكمال الطلب",
          orderAmount: "مبلغ الطلب",
          fusatyCommission: "عمولة Fusaty",
          payoutAmount: "مبلغ الدفع",
          status: "الحالة",
          payoutTimingInfo: "معلومات توقيت الدفع",
          orderCompletionTime: "وقت إكمال الطلب",
          eligibleForPayout: "مؤهل للدفع",
          action: "إجراء",
          autoRelease: "إصدار تلقائي",
          releaseNow: "إصدار الآن",
          hold: "معلّق",
          save: "حفظ",
        },
        catchUps: {
          addTitle: "إضافة اللقاءات",
          save: "حفظ",
          cancel: "إلغاء",
          modalPlaceholder: "سيتم وضع نموذج اللقاءات هنا.",
          title: "العنوان",
          titlePlaceholder: "أدخل العنوان",
          category: "الفئة",
          categoryPlaceholder: "اختر الفئة",
          categories: {
            specialOffers: "عروض خاصة",
            whereToGo: "أين تذهب",
            activities: "أنشطة",
            sports: "رياضة",
            specialDeals: "صفقات خاصة"
          },
          dates: "التواريخ",
          fromDate: "من التاريخ",
          toDate: "إلى التاريخ",
          times: "الأوقات",
          fromTime: "من الوقت",
          toTime: "إلى الوقت",
          contact: "جهة الاتصال",
          link: "وصلة",
          contactPlaceholder: "tel:+971501234567",
          linkPlaceholder: "https://www.xyz.com",
          selectStartTime: "اختر وقت البدء",
          selectEndTime: "اختر وقت الانتهاء"
        },
        map: {
          loading: "جارٍ تحميل الخريطة...",
          selectLocation: "اختر الموقع",
          searchPlaceholder: "حدد الوجهة",
          coordinates: "خط العرض: \"{{lat}}\" | خط الطول: \"{{lng}}\""
        }
      },
    },
  },
  lng: store.getState().language.language,
  fallbackLng: "en",
});

// Subscribe to store changes to update language
store.subscribe(() => {
  const currentLanguage = store.getState().language.language;
  if (i18n.language !== currentLanguage) {
    i18n.changeLanguage(currentLanguage);
  }
});

export default i18n;
